








import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class EmptyFeedStatus extends Vue {}
